<template>
  <div class="d-flex justify-content-center align-items-center w-100 h-100">
    <div class="alert alert-danger" v-if="showError">
      {{ $t('sentence.something_went_wrong') }}
    </div>
    <v-loader v-else />
  </div>
</template>

<script>
import api from '@/common/api';
import { mapGetters } from 'vuex';
import { pageNotFound } from '@/common/utils/notify';
import { fetchExternalParty } from '@/reviewer/api';
import Loader from '@/common/components/Loader.vue';

export default {
  name: 'ExternalInit',
  data() {
    return {
      uid: null,
      rsid: null,
      extraQuery: {},
      showError: false,
    };
  },
  components: {
    'v-loader': Loader,
  },
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    async getOrCreateIdentifier() {
      const response = await api.post(
        'external/',
        {
          party_slug: this.$route.params.slug,
          uid: this.uid,
          rsid: this.rsid,
          ctype: 'set',
        },
      );

      if (response.status !== 200) {
        // Something went wrong, so the user will be screened out to the external party;
        // NB: if this happens, something goes wrong on the server side;
        const externalPartyResponse = await fetchExternalParty(
          this.$route.params.slug,
          this.rsid,
          this.uid,
        );
        if (externalPartyResponse.status !== 200) {
          this.showError = true;
        } else if (externalPartyResponse.data.screen_out_redirect_url) {
          document.location.href = externalPartyResponse.data.screen_out_redirect_url;
        } else {
          this.showError = true;
        }
        return;
      }

      if (response.data.token) {
        this.$store.commit('login', { token: response.data.token });
      }
      await this.$router.push({
        name: 'research-set-review',
        params: {
          uuid: response.data.research_set_uuid,
        },
        query: {
          ep: this.$route.params.slug,
          rsid: this.rsid,
          uid: this.uid,
          ...this.extraQuery,
        },
      });
    },
  },
  created() {
    const {
      ep, rsid, uid, ...extraQuery
    } = this.$route.query;
    this.rsid = rsid;
    this.uid = uid;
    this.extraQuery = extraQuery;
    this.c = this.$route.query.c;

    if (!this.uid || !this.rsid) {
      // incorrect params;
      pageNotFound();
      this.$router.push({ name: 'dashboard' });
    }

    // Make sure there is no user logged in when starting the process;
    this.$store.commit('logout');
    this.getOrCreateIdentifier();
  },
};
</script>
